<template>
  <IdeaActivityNotification
    :notification="notification"
    title="Idea converted to Backlog Item"
    :resourceKey="resourceKey"
  >
    <template #pic>
      <div class="label-pic is-grey">
        <icon
          data="@icon/backlog-icon.svg"
          class="label-pic__icon"
          :fill="true"
          width="var(--icon-24)"
          height="var(--icon-24)"
        />
      </div>
    </template>
  </IdeaActivityNotification>
</template>

<script setup lang="ts">
import { computed } from "vue"

import IdeaActivityNotification from "@/components/Notification/components/IdeaActivityNotification.vue"

import { NotificationIdeaActivity } from "@/models/Notification"

const props = defineProps<{
  notification: NotificationIdeaActivity
}>()

const resourceKey = computed(() => {
  const sequenceNumber = props.notification.displayEvent?.targetSequenceNumber
  return sequenceNumber == null ? "" : `#${sequenceNumber}`
})
</script>
